import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Skeleton from '@material-ui/lab/Skeleton';
import Divider from '@material-ui/core/Divider';

import CloseIcon from '@material-ui/icons/Close';

import Loading from 'app/components/loaders/Loading';

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    marginRight: {
        marginRight: theme.spacing(1)
    },
    marginBottom: {
        marginBottom: theme.spacing(3)
    },
    empty: {
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(5),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
    },
}));

const loaders = [0, 1, 2, 3, 4, 5];

export default function EmailTemplatesDialog(props) {

    const { open, loading, templates, onClose, onSelect } = props;

    const classes = useStyles();
    const history = useHistory();

    const [ selected, setSelected ] = useState(null);

    const handleSelect = () => {
        onSelect({...selected}, false);
    }

    const handleSelectWithEmails = () => {
        onSelect({...selected}, true);
    }

    const handleEdit = () => {
        onSelect(selected.id);
        history.push(`/admin/emails/${selected.id}`);
    }

    const onExited = () => {
        setSelected(null);
    }

    return (
        <Dialog
            aria-labelledby="email-templates-dialog-title"
            open={open}
            aria-describedby="email-templates-dialogue-description"
            fullWidth
            maxWidth="sm"
            onExited={onExited}
            >
            <Loading isLoading={loading}/>
            <DialogTitle id="email-templates-dialog-title">
                <span>Email Templates</span>
                <IconButton aria-label="Cancel" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <Divider />
            {loading ? loaders.map(l => (
                <Skeleton key={l} className={classes.marginBottom} height={40}/>
            )) : templates.length ? (
                <List component="nav" aria-label="templates">
                    {templates.map(t => {
                        return (
                            <ListItem
                                key={t.id}
                                button
                                selected={selected?.id === t.id}
                                onClick={() => setSelected(t)}
                                >
                                <ListItemText primary={t.template_title} />
                            </ListItem>
                        )
                    })}
                </List>
            ) : (
                <Typography
                    align="center"
                    color="textSecondary"
                    variant="subtitle2"
                    className={classes.empty}
                    >
                    You have not saved any templates.
                </Typography>
            )}
            <Divider />
            <DialogActions>
                <Grid container justify="space-between">
                    <Grid item>
                        <Button onClick={handleEdit} variant="outlined" disabled={selected === null}>
                            Edit Template
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={handleSelectWithEmails} color="primary" variant="outlined" className={classes.marginRight} disabled={selected === null}>
                            Use Template with Emails
                        </Button>
                        <Button onClick={handleSelect} color="primary" variant="contained" disabled={selected === null}>
                            Use Template
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}
